import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllAlerts,
  acknowledgeAlertById,
} from "../../redux/slices/AlertSlice";
import "./AdminCSS/Details.css";

const WatchAlerts = () => {
  const dispatch = useDispatch();
  const { alerts, loading, error } = useSelector((state) => state.alerts);

  useEffect(() => {
    dispatch(fetchAllAlerts());
  }, [dispatch]);

  // Only Watch Alerts
  const watchAlerts = alerts.filter(
    (alert) => alert.event_type?.toLowerCase() === "watch"
  );

  const handleAcknowledge = (alert) => {
    dispatch(
      acknowledgeAlertById({
        alertId: alert.alert_id,
        alert_acknowledged: true,
        note: "Acknowledged by Admin",
        user_id: alert.user_id,
      })
    );
  };

  return (
    <div className="Devices-page">
      <h2 style={{ marginBottom: "20px" }}>Watch Alerts</h2>

      {loading && <p>Loading alerts...</p>}
      {error && <p style={{ color: "red" }}>Error fetching alerts</p>}

      {!loading && !error && (
        <div className="table-scroll-container">
          <table className="device-table">
            <thead>
              <tr>
                <th>Alert ID</th>
                <th>Time</th>
                <th>Patient ID</th>
                <th>User ID</th>
                <th>Alert Content</th>
                <th>Status</th>
                <th>Operations</th>
              </tr>
            </thead>

            <tbody>
              {watchAlerts.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No Watch Alerts Found
                  </td>
                </tr>
              )}

              {watchAlerts.map((alert) => (
                <tr key={alert.alert_id}>
                  <td>{alert.alert_id}</td>
                  <td>
                    {new Date(alert.occurred_at).toLocaleString()}
                  </td>
                  <td>{alert.patient_id}</td>
                  <td>{alert.user_id}</td>
                  <td>{alert.alert_content}</td>
                  <td>
                    {alert.alert_acknowledged ? "Acknowledged" : "New"}
                  </td>
                  <td>
                    {!alert.alert_acknowledged ? (
                      <button
                        className="update-btn"
                        onClick={() => handleAcknowledge(alert)}
                      >
                        Acknowledge
                      </button>
                    ) : (
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        ✓
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WatchAlerts;